import { Trans, t } from "@lingui/macro";
import { ExternalLink } from "lucide-react";
import { Room } from "../../models/Room";
import { My } from "../../services/My";
import { Util } from "../../services/Utils/Util";
import { UtilApp } from "../../services/Utils/UtilApp";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/ui/avatar";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";

export const RoomWelcomeMessage: React.FC<{ room: Room }> = ({ room }) => {
    const creatorName = room.users.find(u => u.id == room.creatorId)?.name ?? t`a user`;
    const roomName = room.name;
    const officialSite = Util.getOfficialSiteUrl();
    // room.created는 Firestore Timestamp일 수 있으므로 안전하게 변환
    const createdDate = room.created
        ? (typeof (room.created as any).toDate === 'function'
            ? (room.created as any).toDate()
            : new Date(room.created as any))
        : new Date();
    const date = UtilApp.dateStrToTimeAndDay(createdDate.toISOString(), My.user.lang);

    return (
        <div className="p-4 w-full max-w-3xl mx-auto">
            <Card className="bg-blue-50/40 border-blue-100 shadow-sm">
                <CardHeader className="pb-3">
                    <div className="flex items-center gap-3">
                        <Avatar className="h-10 w-10 border-2 border-white shadow-sm bg-white">
                            <AvatarImage src="assets/icon/favicon.png" />
                            <AvatarFallback className="bg-blue-100 text-blue-600">NP</AvatarFallback>
                        </Avatar>
                        <div>
                            <CardTitle className="text-base text-blue-950">
                                <Trans>Welcome to #{roomName}</Trans>
                            </CardTitle>
                            <p className="text-xs text-blue-500 font-medium mt-0.5">
                                <Trans>Created by {creatorName}</Trans> • {date}
                            </p>
                        </div>
                    </div>
                </CardHeader>
                <CardContent className="grid gap-4">
                    <div className="text-sm text-gray-600 space-y-3 pl-1">
                        <p><Trans>Here are a few tips to get started:</Trans></p>
                        <ul className="space-y-2 text-gray-500">
                            <li className="flex items-start gap-2">
                                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-100 text-[10px] font-bold text-blue-600">1</span>
                                <span><Trans>Check the right panel for members, files, and memos.</Trans></span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-100 text-[10px] font-bold text-blue-600">2</span>
                                <span><Trans>Messages posted before you joined this room are not visible.</Trans></span>
                            </li>
                        </ul>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}